module.exports = __webpack_public_path__ + "static/media/autzu-graphics1.e6d80a7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mediakit/autzu-graphics1.svg
// module id = 1953
// module chunks = 0